<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>众筹解锁项</span>
    </div>
    <div class="cont top">
        <div class="title">众筹解锁项是什么？</div>
        <p>众筹解锁项是指在众筹过程中，项目发起人承诺为支持者提供的额外赠品或功能。当达到某个金额时，相应的解锁项赠品就会被激活。 通过合理的解锁机制设计，可以显著提升用户参与感和传播动力。</p>
    </div>
    <div class="cont">
        <div class="title">怎样设计才能吸引支持者？</div>
        <ul class="no">
            <li>清晰展示解锁机制：达到筹资目标「xx元」后，全部订单解锁「xx赠品」，再叠加赠品图片示意；建议项目上线时，制定1-3个目标档位解锁；</li>
            <li>摩点独享：建议解锁赠品为摩点独享，众筹结束后其他渠道绝版，并在页面中加以明确标注，制造赠品的稀缺感，提升支持者意愿。</li>
            <li>保持灵活性：可在项目上线时，公布1-3个解锁赠品；后续解锁可随项目进度、支持者喜好，灵活决定。</li>
        </ul>
    </div>
    <div class="cont">
        <div class="title">解锁项的核心作用</div>
        <p>解锁项的本质是用 “增量福利” 刺激用户下单、拉新、分享，具体体现在三个层面：</p>
        <ul class="circle">
            <li>
                <strong>制造 “集体目标感”，推动用户主动传</strong>
                解锁项的门槛（如 “筹满 10 万元解锁众筹专属配件”“满15万元解锁图书工艺升级”）会让支持者产生 “为了共同福利努力” 的心理，主动拉身边人参与。这种 “集体任务” 的设定，能把用户从 “被动消费者” 变成 “主动推广者”，带来低成本裂变流量。
            </li>
            <li>
                <strong>降低决策门槛，刺激犹豫用户下单</strong>
                <p>解锁项的门槛（如 “筹满 10 万元解锁众筹专属配件”“满15万元解锁图书工艺升级”）会让支持者产生 “为了共同福利努力” 的心理，主动拉身边人参与。这种 “集体任务” 的设定，能把用户从 “被动消费者” 变成 “主动推广者”，带来低成本裂变流量。</p>
            </li>
            <li>
                <strong>延长项目热度，维持长期吸引力</strong>
                <p>众筹通常持续 1-3 个月，解锁项能通过 “阶梯式目标” 让项目保持新鲜感：</p>
            </li>
        </ul>
    </div>
    <div class="cont">
        <div class="title">创建解锁目标</div>
        <p>发布入口，在项目管理概览页-常用工具-解锁目标，下图已经标记好</p>
        <el-image 
            class="enlarged pc-image"
            :src="goalEnter"
            :preview-src-list="imageList"
            :initial-index="0"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p style="padding: 60px 0 0 0;">开始创建</p>
        <el-image 
            class="enlarged pc-image"
            :src="goalCreate"
            :preview-src-list="imageList"
            :initial-index="1"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p style="padding: 60px 0 0 0;">第1步：选择福利获得方式，共3种</p>
        <ul class="no" style="padding: 20px;">
            <li>每个用户ID获得1次：每个用户 ID 仅可获得1 次解锁福利（与订单数量、回报档购买份数无关）。解锁不同档位后，所有档位奖励可累计叠加</li>
            <li>每个订单获得1次：每个订单可独立获得1 次解锁福利。解锁不同档位后，所有档位奖励可累计叠加。例如：购买 N 笔订单，完成任意一个解锁目标后，可获得N 次解锁福利（每笔订单各 1 次）</li>
            <li>每份回报档获得1次：每份回报档可独立获得1 次解锁福利。解锁不同档位后，所有档位奖励可累计叠加。例如：购买 N 份同一回报档，完成任意一个解锁目标后，可获得N 次解锁福利（每份回报档各 1 次）</li>
            <li>项目发起人常选每个用户ID获得1次。即用户不管买多笔订单或多份回报档，每个解锁目标只会获得1份；</li>
        </ul>
        <p>第2步：设置解锁条件，解锁目标和购买档位时必填，用户互动任务是非必填项。若互动任务打开，可选择邀请好友分享或看好项目，邀请好友看好项目的任务难度稍高可降低邀请人数；</p>
        <p style="padding: 10px 0 20px 0;">第3步：添加解锁奖品，注意：若无商品编码可暂时不用填写；发货方式若选择实物需要上传物流单号，若无物流单会影响之后结算，选择虚拟时需上传虚拟码；用户需完成所有解锁条件后才能获得奖励。</p>
        <el-image 
            class="enlarged pc-image"
            style="width: 400px;margin: 20px 0 20px 20px;"
            :src="goalAdd"
            :preview-src-list="imageList"
            :initial-index="2"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p>第4步：发布解锁目标，发布后解锁目标及奖品不支持修改，请在发布前认真检查。</p>
    </div>
    <div class="cont">
        <div class="title">用户端展示</div>
        <p style="margin:0 0 20px 0;">解锁目标发布后，会在项目详情页面展示，如下图。</p>
        <el-image 
            class="enlarged app-image"
            :src="goalApp1"
            :preview-src-list="imageList"
            :initial-index="3"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <el-image 
            class="enlarged app-image"
            :src="goalApp2"
            :preview-src-list="imageList"
            :initial-index="4"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
    <div class="cont">
        <div class="title">解锁福利自动生成订单</div>
        <p>当众筹成功时，系统会自动生成用户获得解锁福利订单，可在订单管理后台查看并支持发货。暂不支持售后。</p>
        <el-image 
            class="enlarged pc-image"
            :src="goalOrder"
            :preview-src-list="imageList"
            :initial-index="5"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <el-image 
            class="enlarged pc-image"
            :src="goalDrawer"
            :preview-src-list="imageList"
            :initial-index="6"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
    <div class="cont">
        <div class="title">解锁福利发货</div>
        <p>在发货管理-待发货订单，解锁订单随主商品（回报档）导出待发货订单。切勿忘记解锁订单发货。</p>
        <p>需注意导出的发货单，若同一个订单号有多个商品会多行展示。发起人可自行合并订单发货，但上传发货单至摩点系统必须是与导出的订单一致，一行只有1个商品。</p>
        <el-image 
            class="enlarged pc-image"
            :src="goalXlsx"
            :preview-src-list="imageList"
            :initial-index="7"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const goalEnter = `${CDN_BASE}goals_enter.png`
const goalCreate = `${CDN_BASE}goals_create.png`
const goalAdd = `${CDN_BASE}goals_add.png`
const goalApp1 = `${CDN_BASE}goals_app_1.png`
const goalApp2 = `${CDN_BASE}goals_app_2.png`
const goalOrder = `${CDN_BASE}goals_order.png`
const goalDrawer = `${CDN_BASE}goals_drawer.png`
const goalXlsx = `${CDN_BASE}goals_xlsx.png`

// 图片列表，用于预览
const imageList = [goalEnter, goalCreate, goalAdd, goalApp1, goalApp2, goalOrder, goalDrawer, goalXlsx]

const router = useRouter()
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    &.img{
        .title{
            margin: 0;
        }
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    .tab_title{
        font-weight: 600;
    }
    p{
        font-size: 14px;
        line-height: 21px;
        span{
            font-weight: 600;
        }
    }
    img{
        width: 100%;
        height: auto;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:40px 0 0 40px;
        }
        
        &.app-image {
            width: 230px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        li{
            font-size: 14px;
            line-height: 21px;
            strong{
                line-height: 1;
                display: block;
                padding: 20px 0 10px 0;
                font-weight: 600;
            }
        }
        
        &.no{
            list-style-type: decimal;
            li{
                list-style: decimal;
            }
        }
        
        &.circle{
            list-style-type: disc;
            li{
                list-style: disc;
            }
        }
    }
}
</style>